import React, { useState } from 'react';
import Header from 'components/ui/Header';
import Breadcrumb from 'components/ui/Breadcrumb';
import ContactQuickAccess from 'components/ui/ContactQuickAccess';


import HeroSection from './components/HeroSection';
import CompanyHistory from './components/CompanyHistory';
import CertificationSection from './components/CertificationSection';
import TeamSection from './components/TeamSection';
import ServicePhilosophy from './components/ServicePhilosophy';
import StatisticsSection from './components/StatisticsSection';
import TestimonialsSection from './components/TestimonialsSection';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Breadcrumb />
          
          {/* Hero Section */}
          <HeroSection />
          
          {/* Company History */}
          <CompanyHistory />
          
          {/* Certifications */}
          <CertificationSection />
          
          {/* Team Section */}
          <TeamSection />
          
          {/* Service Philosophy */}
          <ServicePhilosophy />
          
          {/* Statistics */}
          <StatisticsSection />
          
          {/* Testimonials */}
          <TestimonialsSection />
        </div>
      </main>
      
      <ContactQuickAccess />
    </div>
  );
};

export default AboutUs;